export default __webpack_public_path__ + "b2c2be4da017720aadf5d2f22a4e658c.svg";